import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/index";
import Search from "@/components/search";
import Rotation from "@/components/rotation";
import Searchitme from "@/components/searchitme";
import Foot from "@/components/foot";
import Aboution from "@/components/aboution";
import Pagination from "@/components/pagination";
import Upgrade from "@/components/upgrade";
import Vheader from "@/components/vheader";
import CodeLogin from "@/components/codeLogin";
import AccountLogin from "@/components/accountLogin";
import RegisterLogin from "@/components/registerLogin";
import RetrieveLogin from "@/components/retrieveLogin";
import ScanCode from "@/components/scanCode";
import Gallery from "@/views/gallery";
import Videosource from "@/views/videosource";
import Destination from "@/views/destination";
import Photographer from "@/views/photographer";
import Activities from "@/views/activities";
import Vip from "@/vip/vip";
import Vipbuy from "@/vip/vipbuy";
import payAli from "@/vip/payAli.vue";
import payWx from "@/vip/payWx.vue";
import payBank from "@/vip/payBank.vue";
import Login from "@/login/login";

Vue.use(Router);

const router = new Router({
  linkActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: Index,
      meta: { title: "云上世界" }
    },

    {
      path: "/search",
      name: "search",
      component: Search
    },
    // {
    //   path: '/addpic',
    //   name: 'addpic',
    //   component: Addpic
    // },
    // {
    //   path: '/rotation',
    //   name: 'rotation',
    //   component: Rotation
    // },
    // {
    //   path: '/foot',
    //   name: 'foot',
    //   component: Foot
    // },
    // {
    //   path: '/pagination',
    //   name: 'pagination',
    //   component: Pagination
    // },
    // 精品图片展示
    {
      path: "/gallery",
      name: "gallery",
      component: Gallery,
      meta: { title: "精品图片" }
    },
    // 精品视频展示
    {
      path: "/videosource",
      name: "videosource",
      component: Videosource,
      meta: { title: "精品视频" }
    },
    // 目的地影像馆展示
    {
      path: "/destination",
      name: "destination",
      component: Destination,
      meta: { title: "热门目的地影像馆" }
    },
    // 摄影师展示
    {
      path: "/photographer",
      name: "photographer",
      component: Photographer,
      meta: { title: "摄影名家&优秀供稿人" }
    },
    // 大赛征稿展示
    {
      path: "/activities",
      name: "activities",
      component: Activities,
      meta: { title: "大赛征稿" }
    },
    // 瀑布流
    {
      path: "/aboution",
      name: "aboution",
      component: Aboution
    },
    // 会员套餐选择
    {
      path: "/vip",
      name: "vip",
      component: Vip,
      meta: { title: "会员套餐" }
    },
    // 会员购买
    {
      path: "/vipbuy",
      name: "vipbuy",
      component: Vipbuy,
      meta: { title: "会员支付" }
    },
    // 支付宝支付
    {
      path: "/payAli",
      name: "payAli",
      component: payAli,
      meta: { title: "支付宝支付" }
    },
    // 微信支付
    {
      path: "/payWx",
      name: "payWx",
      component: payWx,
      meta: { title: "微信支付" }
    },
    // 银行卡支付
    {
      path: "/payBank",
      name: "payBank",
      component: payBank,
      meta: { title: "银行卡支付" }
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    // 微信二维码
    {
      path: "/scanCode",
      name: "scanCode",
      component: ScanCode
    },
    // 参加活动详情
    {
      path: "/activeDetail",
      name: "activeDetail",
      component: () => import("@/views/activeDetail.vue"),
      meta: { title: "活动详情" }
    },
    // 练习场
    {
      path: "/playGround",
      name: "playGround",
      component: () => import("@/views/playGround.vue")
    },
    // 练习场2
    {
      path: "/playGround1",
      name: "playGround1",
      component: () => import("@/views/playGround1.vue")
    },
    // 图片详情页
    {
      path: "/photoDetail",
      name: "photoDetail",
      component: () => import("@/views/Detail/photoDetail.vue"),
      meta: { title: "图片详情" }
    },
    // 视频详情页
    {
      path: "/videoDetail",
      name: "videoDetail",
      component: () => import("@/views/Detail/videoDetail.vue"),
      meta: { title: "视频详情" }
    },
    // 搜索结果
    {
      path: "/photoSearchResule",
      name: "photoSearchResule",
      component: () => import("@/views/search/photoSearch-resule.vue"),
      meta: { title: "搜索结果" }
    },
    // 供稿人平台
    {
      path: "/contributor",
      name: "contributor",
      component: () => import("@/views/contributor/index.vue"),
      meta: { title: "供稿人平台" }
    },
    // 摄影师认证
    {
      path: "/authentication",
      name: "authentication",
      component: () => import("@/views/authentication.vue"),
      meta: { title: "摄影师认证" }
    },
    // 用户主页
    {
      path: "/userIndex",
      name: "userIndex",
      component: () => import("@/views/userIndex/index.vue"),
      meta: { title: "用户主页" }
    },
    // 我的作品
    {
      path: "/myWork",
      name: "myWork",
      component: () => import("@/views/myWork/index.vue"),
      meta: { title: "我的主页" }
    },
    // 影像馆主页
    {
      path: "/destinationHome",
      name: "destinationHome",
      component: () => import("@/views/myWork/destinationHome.vue"),
      meta: { title: "影像馆中心" }
    },
    // 商品支付信息页面
    {
      path: "/onBuyInfo",
      name: "onBuyInfo",
      component: () => import("@/views/onBuy/onBuyInfo.vue"),
      meta: { title: "支付信息" }
    },
    // 支付宝购买商品
    {
      path: "/aliBuy",
      name: "aliBuy",
      component: () => import("@/views/onBuy/aliBuy.vue"),
      meta: { title: "支付宝支付" }
    },
    // 微信购买商品
    {
      path: "/wxBuy",
      name: "wxBuy",
      component: () => import("@/views/onBuy/wxBuy.vue"),
      meta: { title: "微信支付" }
    },
    // 银行卡购买商品
    {
      path: "/bankBuy",
      name: "bankBuy",
      component: () => import("@/views/onBuy/bankBuy.vue"),
      meta: { title: "银行卡支付" }
    },
    // 去支付会员订单（支付宝）
    {
      path: "/goPayAli",
      name: "goPayAli",
      component: () => import("@/views/goPay/goPayAli.vue"),
      meta: { title: "支付宝" }
    },
    // 去支付会员订单（微信）
    {
      path: "/goPayWx",
      name: "goPayWx",
      component: () => import("@/views/goPay/goPayWx.vue"),
      meta: { title: "微信" }
    },

    // 去支付图片订单（支付宝）
    {
      path: "/photoPayAli",
      name: "photoPayAli",
      component: () => import("@/views/goPay/photoPayAli.vue"),
      meta: { title: "支付宝" }
    },

    // 去支付图片订单（微信）
    {
      path: "/photoPayWx",
      name: "photoPayWx",
      component: () => import("@/views/goPay/photoPayWx.vue"),
      meta: { title: "微信" }
    },

    // 去支付图片订单（支付宝）
    {
      path: "/videoPayAli",
      name: "videoPayAli",
      component: () => import("@/views/goPay/videoPayAli.vue"),
      meta: { title: "支付宝" }
    },

    // 去支付图片订单（微信）
    {
      path: "/videoPayWx",
      name: "videoPayWx",
      component: () => import("@/views/goPay/videoPayWx.vue"),
      meta: { title: "微信" }
    },
    {
      path: "/shopPay",
      name: "shopPay",
      component: () => import("@/views/shopPay/pay.vue"),
      meta: { title: "购物车支付" }
    },
    {
      path: "/shopWxPay",
      name: "shopWxPay",
      component: () => import("@/views/shopPay/wxPay.vue"),
      meta: { title: "微信支付" }
    },
    {
      path: "/shopAliPay",
      name: "shopAliPay",
      component: () => import("@/views/shopPay/aliPay.vue"),
      meta: { title: "支付" }
    },
    // 文旅营销
    {
      path: "/marketing",
      name: "marketing",
      component: () => import("@/views/Marketing/index.vue"),
      meta: { title: "文旅营销" }
    },
    {
      path: "/wh",
      name: "wh",
      component: () => import("@/views/wh.vue"),
      meta: { title: "云上世界" }
    },
    // vr视频
    {
      path: "/VR",
      name: "VR",
      component: () => import("@/views/VR/VR.vue"),
      meta: { title: "VR视频" }
    },
    // VR视频下单
    {
      path: "/VR_placeOrder",
      name: "VR_placeOrder",
      component: () => import("@/views/VR/VR_placeOrder.vue"),
      meta: { title: "VR视频下单" }
    },
    // VR支付宝购买商品
    {
      path: "/VR_aliBuy",
      name: "VR_aliBuy",
      component: () => import("@/views/VR/VR_aliBuy.vue"),
      meta: { title: "支付宝支付" }
    },
    // VR微信购买商品
    {
      path: "/VR_wxBuy",
      name: "VR_wxBuy",
      component: () => import("@/views/VR/VR_wxBuy.vue"),
      meta: { title: "微信支付" }
    },


    // {
    //   path: '/taizhouActive',
    //   name: 'taizhouActive',
    //   component: () => import('@/other/taizhouActive.vue'),
    //   meta: { title: '【直播】“追光浙东南 踏春浙山海”——2023年浙东南旅游联合体全网互动大直播' }
    // },
    // {
    //   path: '/activeCode',
    //   name: 'activeCode',
    //   component: () => import('@/other/activeCode.vue'),
    //   meta: { title: '【直播】“追光浙东南 踏春浙山海”——2023年浙东南旅游联合体全网互动大直播' }
    // },
    // 关于我们
    {
      path: "/about",
      name: "about",
      component: () => import("@/components/about.vue"),
      meta: { title: "关于我们" }
    },


    //地图
    {
      path: "/map_active",
      name: "map_active",
      component: () => import("@/views/map_active/index.vue"),
      meta: { title: "活动" }
    },

    // 宋韵数字影像馆
    {
      path: "/songyunHome",
      name: "songyunHome",
      component: () => import("@/views/sy/songyunHome.vue"),
      meta: { title: "宋韵文化数字影像馆" }
    },
    // 宋韵开封
    {
      path: "/songyunKaifeng",
      name: "songyunKaifeng",
      component: () => import("@/views/sy/songyunKaifeng.vue"),
      meta: { title: "宋韵开封数字影像馆" }
    },
    // 宋韵杭州
    {
      path: "/songyunhangzhou",
      name: "songyunhangzhou",
      component: () => import("@/views/sy/songyunhangzhou.vue"),
      meta: { title: "宋韵杭州数字影像馆" }
    },
    // 宋韵绍兴
    {
      path: "/songyunshaoxing",
      name: "songyunshaoxing",
      component: () => import("@/views/sy/songyunshaoxing.vue"),
      meta: { title: "宋韵绍兴数字影像馆" }
    },
    // 风雅宋
    {
      path: "/fys",
      name: "fys",
      component: () => import("@/views/sy/fys.vue"),
      meta: { title: "风雅宋" }
    },
    // 视频展示
    {
      path: "/showVideo",
      name: "showVideo",
      component: () => import("@/views/sy/components/showVideo.vue"),
      meta: { title: "视频" }
    },
    // 图片展示
    {
      path: "/showImg",
      name: "showImg",
      component: () => import("@/views/sy/components/showImg.vue"),
      meta: { title: "图片" }
    }
  ]
});

// 防止报错

const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err);
};

export default router;



//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = null
// module chunks = 